import Rest from '../rest'

/******************************************************************************
 *  Form Tracker
 *****************************************************************************/

/**
 * @type {ERP}
 */
export default class ERP extends Rest {

    /**
     * @param {String} resource
     */
    constructor () {
        super('integrations/erp')
    }

    getMapsFields(){
        return this.http2.get(
            this.resource + '/fields-mapping'
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getIntegrations() {
        return this.http2.get(this.resource)
            .then(response => {
                if (response.data && response.data.status === 'error') return Promise.reject(response)

                return response
            })
    }
    
    getProducts(integrationId) {
        return this.http2.get(
            `${this.resource}/${integrationId}/products`
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    getUnits(data) {
        return this.http2.get(
            `${this.resource}/${data.integrationId}/units?productCode=${data.productCode}&subsidiaryCode=${data.subsidiaryCode}&productNumber=${data.productNumber}`
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

}